const country = [
  {
    code: 'FR',
    label: null,
  },
  {
    code: 'PT',
    label: null,
  },
  {
    code: 'BE',
    label: null,
  },
  {
    code: 'IT',
    label: null,
  },
  {
    code: 'CH',
    label: null,
  },
  {
    code: 'ES',
    label: null,
  },
  {
    code: 'DE',
    label: null,
  },
  {
    code: 'NL',
    label: null,
  },
  {
    code: 'LU',
    label: null,
  },
];

export default country;



// WEBPACK FOOTER //
// ./constants/Country.js